var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6757 10.2629C23.0828 10.636 23.1104 11.2686 22.7372 11.6757L14.4872 20.6757C14.2977 20.8824 14.0303 21 13.75 21C13.4697 21 13.2023 20.8824 13.0129 20.6757L9.26285 16.5848C8.88966 16.1777 8.91716 15.5451 9.32428 15.1719C9.7314 14.7987 10.364 14.8263 10.7372 15.2334L13.75 18.5201L21.2629 10.3243C21.636 9.91716 22.2686 9.88966 22.6757 10.2629Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterSucess);
export default __webpack_public_path__ + "static/media/toaster-sucess.face005a45b4f684745e3fab6570c4e5.svg";
export { ForwardRef as ReactComponent };